module.exports = __webpack_public_path__ + "img/tmp-patients-status-1.f8d925cd.svg";